import React from "react"
import {Link} from 'gatsby';
import cn from "classnames";
import * as styles from "./ButtonLink.module.scss"


const ButtonLink = ({
      children,
      linkTo,
      externalLink = false,
      id,
      inHeaderElement = false,
      isColored = false,
      target= "_self",
      className,
      onClick
}) => {
  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <>
      {externalLink ? (
        <a
          href={linkTo}
          className={cn(styles.root, inHeaderElement && styles.headerFix, isColored && styles.colored, className)}
          target={target}
          onClick={handleClick}
        >
          {children}
        </a>
      ) : (
        <Link
          to={linkTo}
          className={cn(styles.root, inHeaderElement && styles.headerFix, isColored && styles.colored, className)}
          target={target}
          onClick={handleClick}
        >
          {children}
        </Link>
      )}
    </>
  )
}

export default ButtonLink
